import React from 'react';

import {Button} from '@famly/mf_input_button';
import {needsTranslations} from 'web-app/util/scoped-needs-translation';
import {Box} from '@famly/mf_layout_box';
import {Tooltip} from '@famly/mf_data-display_tooltip';
import {Text} from '@famly/mf_data-display_text';

import type {HandleModalToggle, Tuition} from '../types';

type Props = {
    canOverridePrice: boolean;
    onRemoveField: () => void;
    index: number;
    fields: {
        id: string;
    }[];
    selectedTuition: Tuition | undefined;
    handleModalToggle: HandleModalToggle;
};

export const EditTuitionButton = ({
    canOverridePrice,
    onRemoveField,
    index,
    fields,
    selectedTuition,
    handleModalToggle,
}: Props) => {
    const canRemove = fields.length > 1 || index !== 0;

    if (!canOverridePrice && !canRemove) {
        return null;
    }

    return (
        <Box marginLeft={2} display="flex" alignItems="center">
            {canOverridePrice && Boolean(selectedTuition) && (
                <Tooltip
                    tooltipContent={
                        <Text variant="body-small">{needsTranslations('SimplifiedUsBilling', 'Override price')}</Text>
                    }
                    placement="top"
                    backgroundColor="n500"
                    color="n0"
                >
                    <Box component="span" marginRight={canRemove ? 1 : 0}>
                        <Button
                            icon="attach_money"
                            variant="tertiary"
                            onClick={() => {
                                if (selectedTuition) {
                                    handleModalToggle({
                                        type: 'overrideTuitionPrice',
                                        payload: {tuition: selectedTuition},
                                    });
                                }
                            }}
                            aria-label={needsTranslations('SimplifiedUsBilling', 'Override price')}
                            data-e2e-id={`override-price-button-${index}`}
                        />
                    </Box>
                </Tooltip>
            )}

            {canRemove && (
                <Tooltip
                    tooltipContent={
                        <Text variant="body-small">{needsTranslations('SimplifiedUsBilling', 'Remove tuition')}</Text>
                    }
                    placement="top"
                    backgroundColor="n500"
                    color="n0"
                >
                    <Box component="span">
                        <Button
                            data-e2e-id={`remove-tuition-button-${index}`}
                            variant="tertiary"
                            icon="delete"
                            aria-label={needsTranslations('SimplifiedUsBilling', 'Remove tuition')}
                            onClick={onRemoveField}
                        />
                    </Box>
                </Tooltip>
            )}
        </Box>
    );
};
